import React from 'react';
import PropTypes from 'prop-types';
import {isMobile} from "../../util/navigator";
import AppMobileBanner from "./AppMobileBanner";
import AppPcBanner from "./AppPcBanner";
import "./AppTopBanner.css";

export default function AppTopBanner({hostname, userAgent, isVisible}) {
    const mobile = isMobile(userAgent);

    if (!isVisible) {
        return null;
    }

    return (
        <div className="AppTopBanner">
            {mobile ? <AppMobileBanner userAgent={userAgent} hostname={hostname} /> : <AppPcBanner />}
        </div>
    );
}

AppTopBanner.propTypes = {
    hostname: PropTypes.string.isRequired,
    userAgent: PropTypes.string.isRequired,
    isVisible: PropTypes.bool.isRequired,
};
